;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"1b60ac3fe5d192af954a6a43dd88d01882eb3a36"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'
import { getSentryBaseOptions } from './sentry.shared.js'

Sentry.init({
  ...getSentryBaseOptions(),
  integrations: [
    Sentry.replayIntegration({
      stickySession: true,
    }),
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
  ],
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  denyUrls: [
    /.*\.mediaad\.org\.*/,
    /.*\.yektanet\.com\.*/,
    /.*\.adtodate\.ir\.*/,
    /.*\.goftino\.com\.*/,
    /.*\.google-analytics\.com\.*/,
  ],
  ignoreErrors: [
    'Cancel rendering route',
    'https://reactjs.org/docs/error-decoder.html?invariant=423',
    'https://reactjs.org/docs/error-decoder.html?invariant=425',
    'https://reactjs.org/docs/error-decoder.html?invariant=418',
  ],

  beforeSend(event) {
    const message = event.message || ''
    const exceptionValue = event.exception?.values?.[0]?.value || ''
    const exceptionType = event.exception?.values?.[0]?.type || ''

    const payload =
      `${message} ${exceptionValue} ${exceptionType}`.toLowerCase()
    if (
      payload.includes('hydration') ||
      payload.includes('hydrating') ||
      payload.includes('hydrated') ||
      payload.includes('server-rendered html')
    ) {
      return null
    }

    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.filter(
        b => !(b.category === 'console' && b.level === 'warning'),
      )
    }

    return event
  },
})
